//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";

const DetailsService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/details/loadscreenview", { id }, successCallback, failureCallback);
    },
    crawlWord: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/list/crawlwordlist", { words: [id], forceReCrawl: true }, successCallback, failureCallback);
    },
    previousOrNextWord: (id, previousOrNext, level, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/word/details/previousornext", { id, previousOrNext, level }, successCallback, failureCallback);
    },
};

export default DetailsService;
